<template>
    <div>
        <form v-show="showForm" class="order-form" @submit.prevent="onSubmit">
            <p class="error" v-if="errors.length">
                <b>Please correct the following error(s):</b>
                <ul style="list-style: none">
                    <li v-for="error in errors" :key="error">{{ error }}</li>
                </ul>
            </p>
            <p class="error" v-if="backendErrors.length"> 
                <ul style="list-style: none">
                    <li v-for="error in backendErrors" :key="error">{{ error }}</li>
                </ul>
            </p>
            <div class="input-align">
                <h4>{{ timeslotMessageStart }} <span class="soft">{{ timeslotMessageEnd }}</span></h4>
                <div v-for="menu_item in menu_items" :key="menu_item.id" class="menu-item-wrapper">
                    <div class="plus-minus">
                        <div class="pm-control minus" v-show="quantity[menu_item.name] > 0" @click="updateQuant(menu_item.name, -1, menu_item.price)">-</div>
                        <div class="pm-value" v-show="quantity[menu_item.name] > 0">{{ quantity[menu_item.name] }}</div>
                        <div class="pm-control" @click="updateQuant(menu_item.name, 1, menu_item.price)">+</div>
                    </div>
                    <div class="menu-item">
                        <h5>{{ menu_item.name }}</h5>
                        <h6>${{ menu_item.price }}</h6>
                    </div>
                </div>

                <div v-show="this.merch.length > 0">
                    <label style="display: inline; padding: 10px" for="merch">Merch</label>
                    <div v-for="item in orderedMerch" :key="item.id">
                        <Merch :merch="merch" :item=item @valueChanged="sumOrderedMerch()"/>
                    </div>
                    <button type="button" @click="addMerch">&#43;</button>
                </div>

                <br style="clear:both;" />

                <div v-show="this.add_ons.length > 0">
                    <h4>Add Ons: </h4>
                    <div class="menu-item-wrapper" v-for="add_on in add_ons" :key="add_on.id">
                        <div class="plus-minus">
                            <div class="pm-control minus" v-show="addonQuantity(add_on) > 0" @click="updateAdds(add_on, -1)">-</div>
                            <div class="pm-value" v-show="addonQuantity(add_on) > 0">{{ addonQuantity(add_on) }}</div>
                            <div class="pm-control" @click="updateAdds(add_on, 1)">+</div>
                        </div>
                        <div class="addon-item">
                            <h5>{{ add_on.name }}</h5>
                            <h6>${{ add_on.price }}</h6>
                        </div>
                    </div>
                </div>

                <br style="clear:both;" />

                <div class="contact-section">
                    <h4>Contact:</h4>
                    <div>
                        <h5 class="left-align" for="name">Name: </h5>
                        <input id="name" v-model="name">
                    </div>

                    <div>
                        <h5 class="left-align" for="email">Email: </h5>
                        <input v-model="email" type="text" id="email" />
                    </div>

                    <div>
                        <h5 class="left-align" for="phoneNumber">Phone Number: </h5>
                        <input v-model="phoneNumber" type="text" id="phoneNumber" placeholder="(optional)"/>
                    </div>

                    <div>
                        <h4 class="left-align" for="comments">Comments: </h4>
                        <textarea v-model="comments" name="comments" class="comments" cols="30" rows="10" placeholder="Have any allergies?  Need to pay with cash?  Let us know here!"></textarea>
                    </div>
                </div>
            </div>

            <br style="clear:both;" />

            <div class="form-group">
                <h4>Total: ${{ chargeAmount }}</h4>
            </div>

            <div class="submit-button" >
                <input type="submit" value="Submit Order" :disabled="this.submitDisabled">
            </div>
        </form>
        <div v-show="!showForm">
            <h3>Pending Order #{{ this.confirmationNumber }}</h3>
                <p>Order Description: {{ orderDescriptionText }} on {{ timeslot.start_time | justDate }} at {{ timeslot.start_time | justTime }}</p>

                <p v-show="this.orderedAddons != ''">Your order includes {{ this.orderedAddons }}.</p>

                <p v-show="this.orderedMerchString != '' && this.releaseType == 'sandwich'">Your order also includes: {{ this.orderedMerchString }}</p>

                <p>Pick up location: {{ this.pickupLocation }} </p>

                <p>Questions, comments, or concerns?  Please DM @carlacafela on Instagram.</p>
                <button v-show="this.timeslot.available_menu_items > 0" @click="orderMore">Order More!</button>
        </div>
    </div>
</template>

<script>
import "vue-select/dist/vue-select.css"
import OrderService from '@/services/OrderService.js'
import Merch from '@/components/Merch.vue'
import moment from 'moment-timezone'
import vSelect from 'vue-select'
import VueNumericInput from 'vue-numeric-input'
import braintree from 'braintree-web'
import Vue from "vue"

Vue.use(VueNumericInput)

export default {
    components: {
        vSelect,
        Merch
    },
    props: {
        releaseType: String,
        timeslot: {
            type: Object,
            required: true
        },
        menu_items: {
            type: Array,
            required: true
        },
        add_ons: {
            type: Array
        },
        merch: {
            type: Array
        },
        pickupLocation: String,
        releaseName: String,
        minimumQuantity: Number,
        timeslotMessageStart: String,
        timeslotMessageEnd: String
    },
    computed: {
        chargeAmount() {
            let sum = 0
            for (var key in this.menuItemValue) {
                sum += this.menuItemValue[key]
            }
            return (sum + this.addonValue).toFixed(2)
        },
        orderDescriptionText() {
            let text = ''
            const quantKeys = Object.keys(this.orderedQuantity)
            const quantVals = Object.values(this.orderedQuantity)
            for (let i = 0; i < quantKeys.length; i++) {
                const currTextBlock = `${quantKeys[i]} ${quantVals[i]} ${this.pluralize(this.menu_items.find(menu_item => menu_item.name === quantKeys[i]).item_type, quantVals[i])}`
                if (i !== quantKeys.length - 1) {
                        text += `${currTextBlock}, `
                } else {
                    if (quantKeys.length !== 1) {
                        text += "and "
                    }
                    text += currTextBlock
                }
            }
            return text
        },
        quantSum() {
            let quantSum = 0
            for (var key in this.quantity) {
                quantSum += this.quantity[key]
            }
            return quantSum
        },
        submitDisabled() {
            return !(this.name && this.quantSum > 0 && (this.quantSum <= this.timeslot.available_menu_items || this.minimumQuantity == 0) && this.validateEmail(this.email)) && !this.pendingOrder
        }
    },
    data() {
        return {
            adds: {},
            orderedAddons: "",
            addonValue: 0,
            backendErrors: [],
            errors: [],
            name: null,
            email: null,
            phoneNumber: null,
            quantity: {},
            menuItemValue: {},
            comments: "",
            showForm: true,
            orderedQuantity: 0,
            confirmationNumber: null,
            pendingOrder: false,
            nonce: "",
            componentKey: 0,
            orderedMerch: [],
            orderedMerchString: "",
            merchSum: 0
        }
    },
    methods: {
        orderDescription() {
            if (this.orderedQuantity > 0 && this.releaseType == 'sandwich') {
                return this.orderedQuantity + ' ' + this.menu_item.name + ' ' + this.pluralize(this.menu_item.item_type, this.orderedQuantity) + ' ' + 'on' + ' ' +  this.$options.filters.justDate(this.timeslot.start_time) + ' ' + 'at' + ' ' + this.$options.filters.justTime(this.timeslot.start_time)
            } else if (this.releaseType == 'merch') {
                return this.orderedMerchString + ' ' + 'on' + ' ' +  this.$options.filters.justDate(this.timeslot.start_time) + ' ' + 'at' + ' ' + this.$options.filters.justTime(this.timeslot.start_time)
            }
        },
        sumOrderedMerch() {
            this.orderedMerch = this.orderedMerch.filter(item => item.item != null)
            if (this.orderedMerch.length > 0) {
                this.orderedMerchString = this.orderedMerch.map(item => item.item.name + ' ' + '-' + ' ' + item.item.size).join(", ")
                const reducer = (accumulator, currentValue) => accumulator + currentValue;
                var justPrices = this.orderedMerch.map(item => parseFloat(item.item.price))
                this.merchSum = justPrices.reduce(reducer)
            } else {
                this.orderedMerchString = ""
                this.merchSum = 0
            }
        },
        addMerch() {
            this.orderedMerch.push({"item": null})
        },
        onSuccess(payload) {
            let nonce = payload.nonce
            this.nonce = nonce
            this.onSubmit()
        },
        onError(error) {
            let message = error.message
            console.log(error)
        },
        addonQuantity(add_on) {
            var divisor = add_on.price
            if (add_on.price == 0 || add_on.price == null) {
                divisor = 1
            }
            
            return this.adds[add_on.name] ? this.adds[add_on.name] / divisor : 0
        },
        updateQuant(name, delta, price) {
            var quant = this.quantity[name] ? this.quantity[name] : 0
            quant = quant + delta
            quant = quant > 0 ? Math.min(quant, this.timeslot.available_menu_items) : 0
            Vue.set(this.quantity, name, quant)
            Vue.set(this.menuItemValue, name, quant * price)
        },
        updateAdds(add_on, delta) {
            var add_on_name = add_on.name
            var addonQuant = this.adds[add_on_name] ? this.addonQuantity(add_on) : 0
            addonQuant = addonQuant + delta
            addonQuant = addonQuant > 0 ? Math.min(addonQuant, 10) : 0
            var total = (add_on.price == 0 || add_on.price == null) ? addonQuant : addonQuant * add_on.price

            this.adds[add_on_name] = total

            var newSum = 0
            for (var key in this.adds) {
                newSum += this.adds[key]
            }

            this.addonValue = newSum
        },
        numbers(quant) {
            let offset = 1
            let internalQuant = quant
            if (this.minimumQuantity != null && this.minimumQuantity < this.timeslot.available_menu_items) {
                offset = this.minimumQuantity
                internalQuant = internalQuant - offset + 1
            }
            return Array.from(Array(internalQuant), (_, i) => i + offset)
        },
        orderMore() {
            this.componentKey += 1
            this.errors = []
            this.orderedMerch = []
            this.orderedMerchString = ""
            this.merchSum = 0
            this.addonValue = 0
            this.showForm = true
        },
        onSubmit() {
        this.errors = []
        if (!this.submitDisabled) {
            this.pendingOrder = true

            var tempArray = []
            var tempDict = {}
            for (var key in this.adds) {
                var add_on = this.add_ons.find(element => element.name === key)
                var quantity = (add_on.price == 0 || add_on.price == null) ? this.adds[key] : this.adds[key]/add_on.price
                tempArray.push(quantity + ' ' + key  )
                tempDict[key] = quantity
            }

            var quant = this.releaseType == "merch" ? 1 : this.quantity
            let order = {
                quantity: quant,
                name: this.name,
                email: this.email,
                phone_number: this.phoneNumber,
                timeslot_id: this.timeslot.id,
                release_id: this.timeslot.release_id,
                comments: this.comments,
                adds: tempDict,
                nonce: this.nonce,
                chargeAmount: this.chargeAmount,
                merch: this.orderedMerch.map(elem => elem.item)
            }

            OrderService.createOrder(order).then(response => {
                this.confirmationNumber = response.data.confirmation_number
                this.showForm = false
                this.pendingOrder = false
                
                if (this.quantSum < this.timeslot.available_menu_items) {
                    this.$emit('order-submitted', this.quantSum)        
                } else if (this.quantSum == this.timeslot.available_menu_items) {
                    this.$emit('decrement-quantity', this.quantSum)
                }

                this.orderedAddons = tempArray.join(", ")
                this.adds = {}
                this.name = null
                this.email = null
                this.phoneNumber = null
                this.comments = null
                this.orderedQuantity = this.quantity
                this.quantity = {}

                this.timeslot.confirmationOpen = true
            }).catch(error => {
                this.pendingOrder = false
                this.backendErrors.push(error.response.statusText)
            })
        } else {
            if (!this.validateEmail(this.email)) this.errors.push("Email required for order confirmation")
            if (this.quantSum >= this.timeslot.available_menu_items && this.minimumQuantity > 0) this.errors.push("Quantity must be less than or equal to the number of items available")
            if (this.quantSum <= 0) this.errors.push('Quantity must be greater than 0')
            if (!this.name) this.errors.push('Name required.')
        }
        }
    },
    filters: {
        justDate: function(date) {
            return moment(date).format('dddd, MMMM Do YYYY')
        },
        justTime: function(date) {
            return moment(date).format('h:mma')
        },
        fullDate: function(date) {
            return moment(date).format('MMMM Do, YYYY h:mma')
        }
    }
}
</script>

<style>
.error {
    color: red;
}
.order-form { 
    display: flex;
    flex-direction: column;
    align-items: center;
}

.addonWrapper {
    padding-bottom: 20px;
}

.comments {
    padding: 0.5em
}

.form-wrapper {
    display: inline-block;
    margin: 0.5em;
    box-sizing: border-box;
}

.input-align {
    display: flex;
    flex-direction: column;
}

textarea, input, label {
    box-sizing: border-box;
    width: 100%;
}

.vue-numeric-input {
    margin: 0 auto;
}

.plus-minus {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 18px;
    font-weight: bold;
    font-size: 13px;
    margin-right: 10px;
}

.plus-minus .pm-control {
    border-radius: 50%;
    background-color: #f5d9dd;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    cursor: pointer;
}

.plus-minus .pm-control.minus {
    line-height: 17px;
}

.menu-item-wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: .5em;
}

.menu-item-wrapper .menu-item {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
}

.plus-minus .pm-value {
    margin: 0 8px;
}

.contact-section > * {
    margin-bottom: 2em;
}

.submit-button input {
    height: 30px;
    width: 285px;
    max-width: 90%;
    background-color: #f5d9dd;
    color: #2D4D50;
    border-radius: 20px;
    border: none;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    text-align: center;
}

.submit-button input:disabled {
    background-color: #D1D3D4;
    color: #808285;
    cursor: default;
}

@supports (-webkit-appearance: -apple-pay-button) { 
    .apple-pay-button {
        display: inline-block;
        -webkit-appearance: -apple-pay-button;
    }
    .apple-pay-button-black {
        -apple-pay-button-style: black;
    }
    .apple-pay-button-white {
        -apple-pay-button-style: white;
    }
    .apple-pay-button-white-with-line {
        -apple-pay-button-style: white-outline;
    }
}

@supports not (-webkit-appearance: -apple-pay-button) {
    .apple-pay-button {
        display: inline-block;
        background-size: 100% 60%;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        border-radius: 5px;
        padding: 0px;
        box-sizing: border-box;
        min-width: 200px;
        min-height: 32px;
        max-height: 64px;
    }
    .apple-pay-button-black {
        background-image: -webkit-named-image(apple-pay-logo-white);
        background-color: black;
    }
    .apple-pay-button-white {
        background-image: -webkit-named-image(apple-pay-logo-black);
        background-color: white;
    }
    .apple-pay-button-white-with-line {
        background-image: -webkit-named-image(apple-pay-logo-black);
        background-color: white;
        border: .5px solid black;
    } 
}

</style>
